export default __webpack_public_path__ + "static/media/unseen.8f164cfd.png";